'use strict';

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { AppContainer } from 'react-hot-loader';
import React from 'react';
import ReactDom from 'react-dom';
import { ConfigManager } from '@kailona/core';
import App from './App';
import AppAdminSettings from './AppAdminSettings';
import config from './config/default'; // Set App Config

ConfigManager.appConfig = config; // Enable React devtools

window.React = React;

function render(App, rootElement) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  ReactDom.render( /*#__PURE__*/React.createElement(AppContainer, null, /*#__PURE__*/React.createElement(App, props)), rootElement);
}

$(document).ready(function () {
  var rootElement = document.getElementById('ehr-root');

  if (rootElement) {
    render(App, rootElement);
  }

  var adminSettingsElement = document.getElementById('ehr-admin-settings');

  if (adminSettingsElement) {
    var adminSettings = JSON.parse(adminSettingsElement.getAttribute('data-settings'));
    render(AppAdminSettings, adminSettingsElement, {
      adminSettings: adminSettings
    });
  }

  if (module.hot) {
    module.hot.accept('./App', function () {
      var _require = require('./App'),
          NextApp = _require.App;

      render(NextApp, rootElement);
    });
    module.hot.accept('./AppAdminSettings', function () {
      var _require2 = require('./AppAdminSettings'),
          NextAppAdminSettings = _require2.AppAdminSettings;

      var adminSettings = JSON.parse(adminSettingsElement.getAttribute('data-settings'));
      render(NextAppAdminSettings, adminSettingsElement, {
        adminSettings: adminSettings
      });
    });
  }
});
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(render, "render", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/index.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();